export const baseUrl =
  "https://fcc7-2803-9800-9898-81b0-b94e-9e37-5ad0-bdbe.ngrok-free.app/api";
